import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';
import OverlayTrigger from '../overlay/OverlayTrigger';
import Tooltip from '../tooltip/Tooltip';
// TODO: add responsive behaviour and trigger a change from table to list for small screen -> see DriverAdministration
const wrapWithTooltip = (tooltipContent, element) => (_jsx(OverlayTrigger, { placement: 'bottom', overlay: _jsx(Tooltip, { id: 'tooltip', allowOnTouch: true, children: tooltipContent }), children: element }));
const typeIcons = {
    TABLE: 'rioglyph-table-view',
    SINGLE_CARD: 'rioglyph-th-list',
    MULTI_CARDS: 'rioglyph-split-view',
};
const TypeButton = (props) => {
    const { viewType, currentViewType, disabledViewTypes, tooltipContent, onClick, disabled } = props;
    if (disabledViewTypes.includes(viewType)) {
        return null;
    }
    const classes = classNames('btn btn-default btn-icon-only', disabled && 'disabled pointer-events-none', viewType === currentViewType && 'active');
    const button = (_jsx("button", { className: classes, type: 'button', onClick: () => onClick(viewType), children: _jsx("span", { className: `rioglyph ${typeIcons[viewType]}` }) }));
    return tooltipContent ? wrapWithTooltip(tooltipContent, button) : button;
};
const TableViewToggles = (props) => {
    const { viewType, initialViewType = 'TABLE', disabledViewTypes = [], onViewTypeChange = noop, tableViewTooltipContent, singleCardViewTooltipContent, multiCardsViewTooltipContent, disabled = false, className, ...remainingProps } = props;
    const [internalViewType, setInternalViewType] = useState(initialViewType);
    // update internal state when external state changes - controlled component case
    useEffect(() => {
        if (viewType) {
            setInternalViewType(viewType);
        }
    }, [viewType]);
    const setViewType = (vt) => {
        setInternalViewType(vt);
        onViewTypeChange(vt);
    };
    const wrapperClassNames = classNames('TableViewToggles', 'btn-group', 'display-flex', 'flex-row', className && className);
    return (_jsxs("div", { ...remainingProps, className: wrapperClassNames, children: [_jsx(TypeButton, { viewType: 'TABLE', currentViewType: internalViewType, disabledViewTypes: disabledViewTypes, tooltipContent: tableViewTooltipContent, onClick: setViewType, disabled: disabled }), _jsx(TypeButton, { viewType: 'SINGLE_CARD', currentViewType: internalViewType, disabledViewTypes: disabledViewTypes, tooltipContent: singleCardViewTooltipContent, onClick: setViewType, disabled: disabled }), _jsx(TypeButton, { viewType: 'MULTI_CARDS', currentViewType: internalViewType, disabledViewTypes: disabledViewTypes, tooltipContent: multiCardsViewTooltipContent, onClick: setViewType, disabled: disabled })] }));
};
// Don't export values as string but as a distinct union type
TableViewToggles.VIEW_TYPE_TABLE = 'TABLE';
TableViewToggles.VIEW_TYPE_SINGLE_CARD = 'SINGLE_CARD';
TableViewToggles.VIEW_TYPE_MULTI_CARDS = 'MULTI_CARDS';
export default TableViewToggles;
